import { createSelector } from 'reselect';
import { AnyStateWithRefund, RefundLoadingState, RefundOperation } from '../types';

export const getLoadingState = (state: AnyStateWithRefund) => state.refund.loading;

export const getRefundLoading = createSelector(getLoadingState, loading => Boolean(loading?.size));

export const makeGetRefundLoadingByOperation = (operation: RefundOperation) =>
	createSelector(getLoadingState, (loading: RefundLoadingState) => loading?.has(operation) ?? false);

export const getUpdateOrderLoading = makeGetRefundLoadingByOperation('updateOrder');
